import { inject, observer } from 'mobx-react';

import LoadingIcon from './LoadingIcon';
import React from 'react';
import classNames from 'classnames/bind';
import styles from './LoadingScreen.module.scss';

const cx = classNames.bind(styles);

function LoadingScreen(props) {
  const { children, rootStore } = props;
  if (rootStore.pageLoading) {
    return (
      <div className={cx('loading-screen-container')}>
        <LoadingIcon />
      </div>
    );
  } else {
    return children;
  }
}

export default inject('rootStore')(observer(LoadingScreen));
